import React from 'react';
import { Alert, Box, LinearProgress, Typography } from '@mui/material';
import type { DeliveryQueueJobStatusData } from '../services/firebaseFunctions';
import type { ProcessDeliveryQueueAsyncResult } from './DeliveryQueueProcessButton';

interface DeliveryQueueJobStatusProps {
  asyncMeta: Pick<ProcessDeliveryQueueAsyncResult, 'totalItems' | 'partialResult' | 'message'> | null;
  jobStatus: DeliveryQueueJobStatusData | null;
}

const DeliveryQueueJobStatus: React.FC<DeliveryQueueJobStatusProps> = ({ asyncMeta, jobStatus }) => {
  if (!asyncMeta && !jobStatus) return null;

  const total = jobStatus?.totalItems ?? asyncMeta?.totalItems ?? 0;
  const processed = jobStatus?.processedItems ?? 0;
  const progress = total > 0 ? Math.min(100, Math.round((processed / total) * 100)) : 0;
  const status = jobStatus?.status ?? 'processing';

  return (
    <Box sx={{ mt: 2 }}>
      {asyncMeta?.message && (
        <Typography variant="body2" color="text.secondary" mb={1}>
          {asyncMeta.message}
        </Typography>
      )}

      <LinearProgress variant="determinate" value={progress} sx={{ mb: 1 }} />
      <Typography variant="body2" mb={1}>
        Progresso: {processed} / {total} ({progress}%)
      </Typography>

      {jobStatus && (
        <Typography variant="body2" color="text.secondary">
          Resolvidos: {jobStatus.resolved} · Pendentes: {jobStatus.stillPending} · Erros:{' '}
          {jobStatus.errors}
        </Typography>
      )}

      {status === 'completed' && (
        <Alert severity="success" sx={{ mt: 1 }}>
          Processamento em lote concluído.
        </Alert>
      )}
      {status === 'failed' && (
        <Alert severity="error" sx={{ mt: 1 }}>
          O processamento em lote falhou. Tente novamente.
        </Alert>
      )}
      {status === 'cancelled' && (
        <Alert severity="info" sx={{ mt: 1 }}>
          O processamento em lote foi cancelado.
        </Alert>
      )}
    </Box>
  );
};

export default DeliveryQueueJobStatus;
